import { DefaultMetaTags } from '@common/seo/default-meta-tags'
import { NextUIProvider } from '@nextui-org/react'
import React, { Fragment } from 'react'
import { Footer, Nav } from './landing-page'
import OurMission from './aboutPageComponents/OurMission'
import Numbers from './aboutPageComponents/Numbers'
import Faq from './aboutPageComponents/Faq'
import Vision from './aboutPageComponents/Vision'

export default function About() {
  return (
    <Fragment>
      <NextUIProvider>
        <DefaultMetaTags />
        <div>
          <Nav />
          <OurMission/>
          <Numbers/>
          <Vision/>
          <Faq/>
          <Footer />
        </div>
      </NextUIProvider>
    </Fragment>
  )
}
